define('productPicturesTabPictureItemView',[
  'module',
  'marionette',
  'template!productPicturesTabPictureItemTpl',
  'bootbox',
  'jquery',
  'settings',
  'app',
  'underscore',
  'pluginUtils'
], function (
  module,
  Marionette,
  pictureItemTpl,
  bootbox,
  $,
  Settings,
  App,
  _,
  PluginUtils
) {
  'use strict';

  var PictureItemView = Marionette.ItemView.extend({
    template: pictureItemTpl,
    className: 'picture-elements',

    ui: {
      edit: '.js-edit',
      print: '.js-print',
      'delete': '.js-delete',
      ambiance: '.js-ambiance'
    },

    events: {
      'click @ui.edit': '_edit',
      'click @ui.print': '_print',
      'click @ui.delete': '_delete',
      'click @ui.ambiance': '_ambiance'
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      if (this.model.get('ambiance')) {
        templateData.isAmbiance = this.model.get('ambiance');
      } else {
        templateData.isAmbiance = false;
      }
      templateData.pictureImageUrl = this.model.getImageUrl(160, 120, this.options.productCode, this.options.templateFileUid);
      return templateData;
    },

    _edit: function () {
      PluginUtils.callPlugin({
        action: 'editProductPicture',
        productPictureSecId: this.model.get('secId')
      });
    },

    _print: function () {
      PluginUtils.callPlugin({
        action: 'placePrintArea',
        productPictureSecId: this.model.get('secId')
      });
    },

    _delete: function () {
      var model = this.model;
      bootbox.confirm(_.i18n('common.confirmDelete'), function (result) {
        if (result) {
          model.destroy();
        }
      });
    },

    _ambiance: function () {
      this.model.set('ambiance', !this.model.get('ambiance'));
      this.model.save().then(_.bind(function () {
        this.render();
      }, this));
    }
  });

  module.exports = PictureItemView;
});
